<template>
  <b-overlay :show="busy">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="10" lg="8">

          <b-row>

            <b-col cols="12" lg="8" class="mb-4">
              <div class="div-book-title">{{book.title}}</div>
              <div class="div-book-subtitle">{{book.subtitle}}</div>
              <div>
                <img :src="book.photo" class="w-100" style="max-width:600px;" />
              </div>
              <div class="mt-2 div-book-blurb">{{book.blurb}}</div>
            </b-col>

            <b-col cols="12" lg="4" class="mt-2 mb-2">
              <div class="div-form">
                <div v-if="!success" class="div-book-formtitle">{{book.formTitle}}</div>
                <b-form v-if="!success" @submit.stop.prevent="register">

                  <b-form-group label="Position" label-for="position" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                    <b-form-select id="position" placeholder="" v-model.trim="$v.form.jobTitle.$model" :options="jobTitles" :state="validateState('jobTitle')" aria-describedby="support-position-feedback"></b-form-select>
                    <b-form-invalid-feedback id="support-position-feedback">Select position.</b-form-invalid-feedback>
                  </b-form-group>

                  <!-- First Name -->
                  <b-form-group label="First Name" label-for="firstname" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                    <b-form-input
                        id="firstname"
                        v-model.trim="$v.form.firstname.$model"
                        type="text"
                        placeholder="Your first name"
                        :state="validateState('firstname')"
                        aria-describedby="support-firstname-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="support-firstname-feedback">First name is a required field and must be at least 2 characters.</b-form-invalid-feedback>
                  </b-form-group>

                  <!-- Last Name -->
                  <b-form-group label="Last Name" label-for="lastname" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                    <b-form-input
                        id="lastname"
                        v-model.trim="$v.form.lastname.$model"
                        type="text"
                        placeholder="Your last name"
                        :state="validateState('lastname')"
                        aria-describedby="support-lastname-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="support-lastname-feedback">Last name is a required field and must be at least 2 characters.</b-form-invalid-feedback>
                  </b-form-group>

                  <!-- Email -->
                  <b-form-group label="Email" label-for="email" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                    <b-input-group class="mb-2">
                      <b-input-group-prepend is-text>
                        <b-icon icon="envelope"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input
                        id="email"
                        v-model.trim.lazy="$v.form.email.$model"
                        type="email"
                        placeholder="Your email"
                        :state="validateState('email')"
                        aria-describedby="support-email-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback v-if="!$v.form.email.required">Email is required.</b-form-invalid-feedback>
                      <b-form-invalid-feedback v-if="!$v.form.email.email">Enter valid email address.</b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>

                  <!-- Phone -->
                  <b-form-group label="Telephone (optional)" label-for="phone" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                    <b-input-group class="mb-2">
                      <b-input-group-prepend is-text>
                        <b-icon icon="phone"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input
                        id="phone"
                        v-model.trim.lazy="$v.form.phone.$model"
                        type="tel"
                        placeholder="Your phone number"
                        :state="validateState('phone')"
                        aria-describedby="support-phone-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback v-if="!$v.form.phone.optionalPhone">Provide full phone number.</b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>

                  <b-form-checkbox
                    id="optin"
                    v-if="book.hasOptin"
                    v-model="$v.form.optin.$model"
                    name="optin"
                    value="1"
                    unchecked-value="0"
                    class="mb-2"
                  >
                    {{book.optinText || "Text not available."}}
                  </b-form-checkbox>

                  <transition name="fade" mode="out-in">
                    <b-alert v-model="error" key="error-box" show variant="danger" dismissible class="mt-2">
                      {{errorMsg}}
                    </b-alert>
                  </transition>

                  <b-card bg-variant="light" class="mb-2">
                    {{book.buttonLabel || "Complete all fields and click button below to get this eBook."}}
                    <div class="text-center mt-2 mb-2">
                      <b-button type="submit" variant="danger">
                        <span class="text-nowrap">&nbsp;{{ book.buttonText || "Get eBook" }}&nbsp;</span>
                      </b-button>
                    </div>
                  </b-card>

                </b-form>

                <!-- Success -->
                <transition name="fade" mode="out-in">
                  <b-alert v-model="success" key="success-box" show variant="secondary" class="mt-2">
                    <div>
                      <h4>Thanks for submitting the form!</h4>
                    </div>
                    <div v-if="isPdf" class="div-pdf-link">
                      <a :href="book.pdf" target="_blank">{{ book.payloadLinkText || "View eBook Now"}}</a>
                    </div>
                    <div v-if="isYoutube" class="div-pdf-link">
                      <a :href="getYoutubeUrl" target="_blank">{{ book.payloadLinkText || "View Video Now"}}</a>
                    </div>
                    <div v-if="isUrl" class="div-pdf-link">
                      <a :href="book.url" target="_blank">{{ book.payloadLinkText || "View URL Now"}}</a>
                    </div>

                  </b-alert>
                </transition>

              </div>

            </b-col>

          </b-row>

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"
import constants from "@/config/constants"

import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength, between, sameAs, helpers } from 'vuelidate/lib/validators'
import { T } from "caniuse-lite/data/browserVersions"

// optional phone validator
// https://vuelidate.js.org/#sub-optional-validator
const optionalPhone = (value) => !helpers.req(value) || value.length >= 10

export default {
  name: "Home",
  data() {
    return {
      debug:false,   // logs to console
      error: false,
      errorMsg: null,
      busy: false,
      success: false,
      bookCode: null,
      email: null,    // optional: provided via query parameter "e"
      hash: null,     // optional: newsletterEmails.hash value via query parameter "h"
      studentHash: null,
      book: {
        bookId: 0,
        companyId: 0,
        mediaTypeId: 0,
        code: null,
        hasOptin: false,
        title: null,
        subtitle: null,
        formTitle: null,
        photo: null,
        blurb: null,
        buttonLabel: null,
        buttonText: null,
        pdf: null,
        url: null,
        youtubeCode: null,
        optinText: null,
        payloadLinkText: null,
        hash: null,
        companyName: null
      },
      jobTitles: null,
      form: {
        optin: "0",
        jobTitle: null,
        firstname: null,
        lastname: null,
        phone: null,
        email: null,
        bookHash: null,
        hash: null
      }
    }
  },
  props: {
    // Ebook.code
    c: {
      type: String,
      required: true,
      default: ""
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      optin: {},
      jobTitle: {
        required
      },
      firstname: {
        required,
        minLength: minLength(2)
      },
      lastname: {
        required,
        minLength: minLength(2)
      },
      phone: {
        optionalPhone
        // required,
        // minLength: minLength(10)
      },
      email: {
        required,
        email
      }
    }
  },
  computed: {
    isPdf() {
      return this.book.mediaTypeId == constants.VP_MEDIATYPE.PDF
    },
    isYoutube() {
      return this.book.mediaTypeId == constants.VP_MEDIATYPE.YOUTUBE
    },
    isUrl() {
      return this.book.mediaTypeId == constants.VP_MEDIATYPE.URL
    },
    getYoutubeUrl() {
      return utils.getYoutubeUrl(this.book.youtubeCode, true)
    }
  },
  methods: {
    validateState(name) {
      // console.log(`name: ${name}`)
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null;
    },
    register(e) {  // user filled out form.

        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          console.log(`ERROR!!`)
          this.errorMsg = 'Correct errors and resubmit.'
          this.error = true
          return
        }

        this.error = false
        this.success = false
        this.busy = true
        service
          .saveBookResponse(this.form)
          .then( res => {
            if (this.debug) console.log(res.data)
            if (res.status) {

              // this.$router.push(`/done/${this.book.code}`)

              console.log(`mediaTypeId: ${this.book.mediaTypeId}  VP_MEDIATYPE.PDF: ${constants.VP_MEDIATYPE.PDF}`)

              this.error = false
              this.success = true

              // Re-init whole form
              this.form.firstname = null
              this.form.lastname = null
              this.form.phone = null
              this.form.email = null

            } else {
                this.success = false
                this.errorMsg = res.errorMsg || 'System Error from Register Service.'
                this.error = true
            }
          })
          .finally( () => {
            this.busy = false
          })
          .catch(e => {
            console.log(e);
            this.error = true
          })
    },
    registerRepEmpower() {  // email or hash provided - short circuit

      this.form.jobTitle = 'Sales Rep'
      this.form.firstname = 'Undefined'
      this.form.lastname = 'Undefined'
      this.form.phone = null

      // Validate form fields if hash not provided.
      if (!this.form.hash) {
        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          console.log(`ERROR!!`)
          this.errorMsg = 'Correct errors and resubmit.'
          this.error = true
          return
        }
      }

      this.error = false
      this.success = false
      this.busy = true
      service
        .saveBookResponse(this.form)
        .then( res => {
          if (this.debug) console.log(res.data)
          if (res.status) {

            // this.$router.push(`/done/${this.book.code}`)
            this.error = false
            this.success = true

            // Re-init whole form
            this.form.firstname = null
            this.form.lastname = null
            this.form.phone = null
            this.form.email = null

            if (this.book.mediaTypeId === constants.VP_MEDIATYPE.URL) {
              // proceed directly to url
              window.location.href = this.book.url
            }
            else {
              console.log(`mediaTypeId: ${this.book.mediaTypeId}  VP_MEDIATYPE.PDF: ${constants.VP_MEDIATYPE.PDF}`)
            }
          } else {
              this.success = false
              this.errorMsg = res.errorMsg || 'System Error from Register Service.'
              this.error = true
          }
        })
        .finally(() => {
          this.busy = false
        })
        .catch(e => {
          console.log(e);
          this.error = true
        })
    }
  },
  created() {

    this.bookCode = this.c || this.$route.query.c || null
    this.email = this.$route.query.e || null  // optional email address
    this.hash = this.$route.query.h || null   // optional newsletterEmails.hash
    this.busy = true

    service
      .getBook(this.bookCode)
      .then(
        (res => {
          console.log(`back from getBook`);
          if (this.debug) console.log(res);
          if (res.status) {
            this.book = res.book
            this.form.bookHash = this.book.hash
            this.jobTitles = res.jobTitles
            if (this.email || this.hash) {  // store response if email or hash provided
              if(this.debug) console.log(`Calling registerRepEmpower e: |${this.email}|  hash: |${this.hash}|`)
              this.form.email = this.email
              this.form.hash = this.hash
              this.registerRepEmpower()
            }
          }
          else {
            this.error = true
          }
        }).bind(this)
      )
      .finally(e => {
        this.busy = false
      })
      .catch(e => {
        this.error = true
        console.log(e)
      });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.div-book-title {
  color: #c51749;
  font-family: Poppins,Arial,Sans-Serif;
  margin: 0 0 15px 0;
  font-size: 30px;
  font-weight: 700;
  font-style: normal;
}

.div-book-subtitle {
  font-family: Poppins,Arial,Sans-Serif;
  margin: 0 0 15px 0;
  color: #0d78c0;
  font-weight: 700;
  font-style: normal;
  font-size: 26px;
}

.div-book-blurb {
  color: #000;
  font-family: "Arial","Sans-Serif";
  font-size: 16px;
  line-height: 1.5;
}

.div-book-formtitle {
    font-size: 30px;
    font-weight: 400;
    color: #c51749;
    font-family: Poppins,Arial,Sans-Serif;
    margin: 0 0 15px 0;
    font-style: normal;
}

.div-form {
    box-shadow: 0px 0px 50px -16px rgba(0,0,0,0.75);
    padding: 20px 22px;
}

.div-pdf-link a, .div-pdf-link a:visited {
    font-weight: bold;
    font-size: 1.1rem;
    color: #c51749;
}

.div-pdf-link a:active {
    font-weight: bold;
    font-size: 1.1rem;
    color: #F00;
}

.txt-home-title-part1 {
  font-weight: bold;
  color: #939393;
  font-size: 2rem;
}
.txt-home-title-part2 {
  /* font-weight: bold; */
  color: #3471b3;
  font-size: 1.9rem;
}
.txt-home-subtitle {
  font-weight: bold;
  font-size: 1.1rem;
  line-height: 130%;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue